import { render, staticRenderFns } from "./ClientPortal.vue?vue&type=template&id=2064ee30&"
import script from "./ClientPortal.vue?vue&type=script&lang=js&"
export * from "./ClientPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports